module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-01@2x-780ff1da6a1a7f5c144153fe4a54e9ed.png";